import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import spinner from "../../../assets/iconos/spinner4.svg";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { countNombreEmpresa, modificarEmpresa, registrarEmpresa } from "../../../api/api-empresa";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import TimeZoneComponent from "../../../components/time-zone-component";
import { obtenerPaisCombo } from "../../../api/api-pais";
import Select from "react-select";
import { PAISES } from "../../../utils/const/obj-const";
// import SwitchComponent from "../../../components/switch";
// import LabelConSin from "../../../components/label-con-sin-periodo-prueba";
import { obtenerMonedaCombo } from "../../../api/api-moneda";
import moment from "moment-timezone";

export default function ModificarEmpresa() {
    const location = useLocation();
    const history = useHistory();
    // const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    // const [showPassword, setShowPassword] = useState(false);
    // const [showConfirmarPassword, setShowConfirmarPassword] = useState(false);
    // const [passwordError, setPasswordError] = useState("");
    const [selectedHour, setSelectedHour] = useState("");
    const [cargandoPage, setCargandoPage] = useState(true);
    const [listaPais, setListaPais] = useState([]);
    const [paisSelected, setPaisSelected] = useState(null);
    const [listaMoneda, setListaMoneda] = useState([]);
    const [monedaSelected, setMonedaSelected] = useState(null);
    const [formData, setFormData] = useState({
        codigo: '',
        nombre: '',
        telefonoEmpresa: '',
        emailEmpresa: '',
        representante: '',
        telefonoRepresentante: '',
        emailRepresentante: '',
        timeZone: '',
        usuario: '',
        password: '',
        confirmarPassword: '',
        // limiteVehiculo: '',
        nombreEncargadoCobranza: '',
        cargoCobranza: '',
        telefonoCobranza: '',
        emailCobranza: '',
        razonSocial: '',
        nit: '',
        precioUnitarioVehiculo: '',
        diaFacturacion: '',
    });

    const charLimits = {
        codigo: 64,
        nombre: 128,
        telefonoEmpresa: 64,
        emailEmpresa: 64,
        representante: 128,
        telefonoRepresentante: 64,
        emailRepresentante: 64,
        timeZone: 8,
        usuario: 64,
        password: 256,
        confirmarPassword: 256,
        // limiteVehiculo: 7,
        nombreEncargadoCobranza: 128,
        cargoCobranza: 128,
        telefonoCobranza: 64,
        emailCobranza: 128,
        razonSocial: 128,
        nit: 64,
        diaFacturacion: 2,
    };
    const [isVisible, setIsVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    // const [periodoPrueba, setPeriodoPrueba] = useState(true);
    useEffect(() => {
        iniciar();
    }, []);

    useEffect(() => {
        if (paisSelected?.value === PAISES.BOLIVIA) {
            setShouldRender(true);
            // Slight delay to trigger the fadeIn animation
            setTimeout(() => setIsVisible(true), 10);
        } else if (shouldRender) {
            setIsVisible(false);
            setFormData({
                ...formData,
                razonSocial: "",
                nit: "",
            });
            // After fadeOut duration, unmount
            setTimeout(() => setShouldRender(false), 500);
        }
    }, [paisSelected]);

    const iniciar = async () => {
        try {
            const data = location.state;
            console.log("data");
            console.log(data);
            if (data !== undefined && data !== null) {
                setFormData(data.params);
                // setTitulo(data.titulo);
            }
            const response = await obtenerPaisCombo();
            // console.log('response');
            // console.log(response);
            if (data.params.idPais !== undefined && data.params.idPais !== null) {
                const pais = response.find((item) => item.value === data.params.idPais);
                // console.log('pais');
                // console.log(pais);
                setPaisSelected(pais);
            }
            setListaPais(response);

            const respMoneda = await obtenerMonedaCombo();
            // console.log('respMoneda');
            // console.log(respMoneda);
            if (data.params.idMonedaGenerico !== undefined && data.params.idMonedaGenerico !== null) {
                const moneda = respMoneda.find((item) => item.value === data.params.idMonedaGenerico);
                // console.log('moneda');
                // console.log(moneda);
                setMonedaSelected(moneda);
            }
            setListaMoneda(respMoneda);

            const timezones = moment.tz.names();

            const timezoneHours = Array.from(
                new Set(
                    timezones.map((timezone) => {
                        const offsetMinutes = moment.tz(timezone).utcOffset();
                        return offsetMinutes / 60; // Convert minutes to hours
                    })
                )
            ).sort((a, b) => a - b);
            // console.log("timezoneHours");
            // console.log(timezoneHours);
            if (data.params.timeZone !== undefined && data.params.timeZone !== null) {
                const tz = timezoneHours.find((item) => String(item) === data.params.timeZone);
                // console.log('tz');
                // console.log(tz);
                setSelectedHour(tz);
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleChangeNumber = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const modificar = async () => {
        // console.log('modificar');
        // e.preventDefault();
        // lógica para guardar los cambios
        // console.log('formData');
        // console.log(formData);
        // return;
        let objEnviar = {};
        objEnviar.id = formData.id;
        objEnviar.codigo = formData.codigo;
        objEnviar.nombre = formData.nombre;
        objEnviar.telefonoEmpresa = formData.telefonoEmpresa;
        objEnviar.emailEmpresa = formData.emailEmpresa;

        objEnviar.representante = formData.representante;
        objEnviar.telefonoRepresentante = formData.telefonoRepresentante;
        objEnviar.emailRepresentante = formData.emailRepresentante;
        objEnviar.timeZone = selectedHour;
        // objEnviar.limiteVehiculo = formData.limiteVehiculo;

        objEnviar.precioUnitarioVehiculo = formData.precioUnitarioVehiculo;
        objEnviar.idMoneda = monedaSelected?.value;
        // objEnviar.diasPeriodoPrueba = formData.diasPeriodoPrueba;
        // objEnviar.periodoPrueba = periodoPrueba;

        objEnviar.idPais = paisSelected?.value;
        objEnviar.nombreEncargadoCobranza = formData.nombreEncargadoCobranza;
        objEnviar.cargoCobranza = formData.cargoCobranza;
        objEnviar.telefonoCobranza = formData.telefonoCobranza;
        objEnviar.emailCobranza = formData.emailCobranza;
        objEnviar.diaFacturacion = formData.diaFacturacion;

        objEnviar.razonSocial = formData.razonSocial;
        objEnviar.nit = formData.nit;
        // console.log('objEnviar');
        // console.log(objEnviar);
        if (objEnviar.id !== 0) {
            const response = await modificarEmpresa(objEnviar);
            // console.log('modificado');
            // console.log(modificado);
            if (response.error === false) {
                alert('Se proceso correctamente');
                handleAtrasClick();
            }
            if (response.error === true) {
                alert('No se pudo modificar\n' + response.message);
            }
        }
    };

    const validarStep1 = () => {
        try {
            console.log('validarStep1');
            console.log(formData);
            // console.log('selectedHour', selectedHour);
            let result = { error: true, message: "" };
            let message = "";
            if (formData.nombre.trim().length === 0) {
                message = message + "Debe ingresar nombre empresa" + "\n";
            }
            if (formData.telefonoEmpresa.trim().length === 0) {
                message = message + "Debe ingresar telefono empresa" + '\n';
            }
            if (formData.emailEmpresa.trim().length === 0) {
                message = message + "Debe ingresar email empresa" + '\n';
            }
            if (String(selectedHour).trim().length === 0) {
                message = message + "Debe seleccionar timeZone" + '\n';
            }
            if (formData.precioUnitarioVehiculo === undefined || String(formData.precioUnitarioVehiculo).trim().length === 0) {
                message = message + "Debe ingresar precio unitario vehiculo" + '\n';
            }
            if (monedaSelected === null || monedaSelected === undefined) {
                message = message + "Debe seleccionar moneda" + '\n';
            }
            if (message.length > 0) {
                result.error = true;
                result.message = message;
            } else {
                result.error = false;
            }
            return result;
        } catch (err) {
            console.log('validarStep1 err');
            console.log(err);
            return { error: true, message: err };
        }
    };

    const handleNextStep = async () => {
        try {
            // console.log('handleNextStep');
            // console.log(formData);
            // e.preventDefault();
            const isValid = validarStep1();
            if (isValid.error === true) {
                alert(isValid.message);
                return;
            }
            await modificar();
            setLoading(false);
        } catch (err) {
            console.log('handleNextStep err');
            console.log(err);
            setLoading(false);
        }
    };

    const render = () => {
        // console.log('render correo');
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                // <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <>

                    <div className="w-full bg-white rounded-lg shadow-md p-6">
                        <h2 className="text-2xl font-bold text-left text-[#0F3457] mb-6">Modificar Empresa</h2>
                        {/* <form onSubmit={}> */}
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                    Codigo
                                </label>
                                <input
                                    type="text"
                                    id="codigo"
                                    name="codigo"
                                    value={formData.codigo}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Codigo"
                                    maxLength={charLimits.codigo}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">

                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                    Nombre<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre"
                                    maxLength={charLimits.nombre}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>

                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nitCompany">
                                    Telefono Empresa<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="telefonoEmpresa"
                                    name="telefonoEmpresa"
                                    value={formData.telefonoEmpresa}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Telefono Empresa"
                                    maxLength={charLimits.telefonoEmpresa}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoEmpresa.length}/{charLimits.telefonoEmpresa}</p>

                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">

                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telephoneCompany">
                                    Email Empresa<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="emailEmpresa"
                                    name="emailEmpresa"
                                    value={formData.emailEmpresa}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Email Empresa"
                                    maxLength={charLimits.emailEmpresa}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.emailEmpresa.length}/{charLimits.emailEmpresa}</p>

                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                    Representante
                                </label>
                                <input
                                    type="text"
                                    id="representante"
                                    name="representante"
                                    value={formData.representante}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Representante Empresa"
                                    maxLength={charLimits.representante}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.representante.length}/{charLimits.representante}</p>

                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                    Telefono Representante
                                </label>
                                <input
                                    type="text"
                                    id="telefonoRepresentante"
                                    name="telefonoRepresentante"
                                    value={formData.telefonoRepresentante}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Telefono Representante"
                                    maxLength={charLimits.telefonoRepresentante}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoRepresentante.length}/{charLimits.telefonoRepresentante}</p>

                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                    Email Representante
                                </label>
                                <input
                                    type="text"
                                    id="emailRepresentante"
                                    name="emailRepresentante"
                                    value={formData.emailRepresentante}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Email Representante"
                                    maxLength={charLimits.emailRepresentante}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.emailRepresentante.length}/{charLimits.emailRepresentante}</p>

                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <TimeZoneComponent
                                    selectedHour={selectedHour}
                                    setSelectedHour={setSelectedHour}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            {/* <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="limiteVehiculo">
                                        Limite Vehiculo<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="limiteVehiculo"
                                        name="limiteVehiculo"
                                        value={formData.limiteVehiculo}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="Limite Vehiculo"
                                        min={1}
                                        enable={periodoPrueba}
                                    />
                                </div> */}
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="precioUnitarioVehiculo">
                                    P/U Vehiculo<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="precioUnitarioVehiculo"
                                    name="precioUnitarioVehiculo"
                                    value={formData.precioUnitarioVehiculo}
                                    onChange={handleChangeNumber}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="P/U Vehiculo"
                                    min={1}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="moneda">
                                    Moneda<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    options={listaMoneda}
                                    isSearchable={true} // Boolean props should not be strings
                                    isClearable={true}
                                    value={monedaSelected}
                                    onChange={(event) => setMonedaSelected(event)}
                                    placeholder="Seleccione Moneda"
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                {/* <LabelConSin periodoPrueba={periodoPrueba} />
                                    <div className="flex justify-between items-center">
                                        <input
                                            type="number"
                                            id="diasPeriodoPrueba"
                                            name="diasPeriodoPrueba"
                                            value={formData.diasPeriodoPrueba}
                                            onChange={handleChangeNumber}
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                            placeholder={periodoPrueba ? 'Con ' + "Dias Periodo Prueba" : 'Sin ' + "Dias Periodo Prueba"}
                                            min={1}
                                            disabled={!periodoPrueba}
                                        />
                                        <div className="w-[10px]"></div>
                                        <SwitchComponent isOn={periodoPrueba} handleToggle={() => {
                                            const periodo = !periodoPrueba;
                                            if (periodo === false) {
                                                formData.diasPeriodoPrueba = null;
                                            }
                                            setPeriodoPrueba(periodo);
                                        }} />
                                    </div> */}
                            </div>
                        </div>
                        <br />
                        <h3 className="text-[#0F3457] font-bold" >Datos Cobranza</h3>
                        <hr />
                        <br />
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombreEncargadoCobranza">
                                    Nombre Encargado
                                </label>
                                <input
                                    type="text"
                                    id="nombreEncargadoCobranza"
                                    name="nombreEncargadoCobranza"
                                    value={formData.nombreEncargadoCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre Encargado"
                                    maxLength={charLimits.nombreEncargadoCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nombreEncargadoCobranza?.length}/{charLimits.nombreEncargadoCobranza}</p>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="cargoCobranza">
                                    Cargo Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="cargoCobranza"
                                    name="cargoCobranza"
                                    value={formData.cargoCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Cargo Cobranza"
                                    maxLength={charLimits.cargoCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.cargoCobranza?.length}/{charLimits.cargoCobranza}</p>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telefonoCobranza">
                                    Telefono Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="telefonoCobranza"
                                    name="telefonoCobranza"
                                    value={formData.telefonoCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Telefono Cobranza"
                                    maxLength={charLimits.telefonoCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoCobranza?.length}/{charLimits.telefonoCobranza}</p>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="emailCobranza">
                                    Email Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="emailCobranza"
                                    name="emailCobranza"
                                    value={formData.emailCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Email Cobranza"
                                    maxLength={charLimits.emailCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.emailCobranza?.length}/{charLimits.emailCobranza}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="diaFacturacion">
                                    Dia Facturacion
                                </label>
                                <input
                                    type="number"
                                    id="diaFacturacion"
                                    name="diaFacturacion"
                                    value={formData.diaFacturacion}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Dia Facturacion"
                                    maxLength={charLimits.diaFacturacion}
                                    min={1}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.diaFacturacion?.length}/{charLimits.diaFacturacion}</p>
                            </div>
                        </div>
                        <br />
                        <h3 className="text-[#0F3457] font-bold" >Extra</h3>
                        <hr />
                        <br />
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="pais">
                                    Pais
                                </label>
                                <Select
                                    options={listaPais}
                                    isSearchable={true} // Boolean props should not be strings
                                    isClearable={true}
                                    value={paisSelected}
                                    onChange={(event) => setPaisSelected(event)}
                                    placeholder="Seleccione Pais"
                                />
                            </div>
                        </div>
                        {shouldRender && (
                            <div
                                style={{
                                    animation: `${isVisible ? "fadeIn" : "fadeOut"} 0.5s ease-in-out`,
                                }}
                            >
                                <style>
                                    {`
                                                @keyframes fadeIn {
                                                from { opacity: 0; transform: translateY(10px); }
                                                to { opacity: 1; transform: translateY(0); }
                                                }
                                                @keyframes fadeOut {
                                                    from { opacity: 1; transform: translateY(0); }
                                                    to { opacity: 0; transform: translateY(10px); }
                                                }                                                
                                            `}
                                </style>
                                <br />
                                <h3 className="text-[#0F3457] font-bold">DATOS FACTURACION</h3>
                                <hr />
                                <br />
                                <div className="grid grid-cols-12 gap-4">
                                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="razonSocial">
                                            Razon Social
                                        </label>
                                        <input
                                            type="text"
                                            id="razonSocial"
                                            name="razonSocial"
                                            value={formData.razonSocial}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                            placeholder="Razon Social"
                                            maxLength={charLimits.razonSocial}
                                        />
                                        <p className="text-sm text-gray-500 flex justify-end">{formData.razonSocial?.length}/{charLimits.razonSocial}</p>
                                    </div>
                                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nit">
                                            Razon Social
                                        </label>
                                        <input
                                            type="text"
                                            id="nit"
                                            name="nit"
                                            value={formData.nit}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                            placeholder="NIT"
                                            maxLength={charLimits.nit}
                                        />
                                        <p className="text-sm text-gray-500 flex justify-end">{formData.nit?.length}/{charLimits.nit}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="flex justify-between items-center">
                            <button
                                onClick={handleAtrasClick}
                                className="text-center text-[#0F3457] mt-4 cursor-pointer hover:underline"
                            >
                                Atras
                            </button>
                            {loading === false &&
                                <button
                                    className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                    onClick={() => { handleNextStep(); }}
                                >
                                    Guardar
                                </button>
                            }
                            {loading === true &&
                                <button
                                    className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                                >
                                    <img className="spinner" alt="spinner" src={spinner} />
                                </button>

                            }
                        </div>
                        {/* </form> */}

                    </div>


                </>
            );
        } catch (err) {
            console.log('Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
